import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './style.scss'

import React, { useCallback, useEffect, useMemo, useRef } from 'react'

import { Editor as DraftEditor } from 'react-draft-wysiwyg'
import { convertToRaw } from 'draft-js'
import { formEvent } from '../Form/Form'
import useDelayedRun from '../../hooks/useDelayedRun'

const TextEditor = ({ name, label, initialValue, required, ref }) => {
  const editorElement = useRef()

  const contentState = useMemo(() => {
    return initialValue ? JSON.parse(initialValue) : undefined
  }, [initialValue])

  const sendValue = useCallback(
    (value) => {
      if (ref) ref.current = value
      if (name) {
        editorElement.current.dispatchEvent(
          formEvent({
            action: 'UPDATE',
            name,
            value
          })
        )
      }
    },
    [ref, name]
  )

  const [setValue, flush] = useDelayedRun(sendValue, 3000, initialValue)

  const handleEditorStateChange = useCallback(
    (state) => {
      setValue(() => JSON.stringify(convertToRaw(state.getCurrentContent())))
    },
    [setValue]
  )

  useEffect(() => {
    sendValue(JSON.stringify(contentState))
  }, [sendValue, contentState])

  useEffect(() => {
    if (name) {
      editorElement.current.dispatchEvent(
        formEvent({
          action: 'REQUIRED',
          name,
          required
        })
      )
    }
  }, [name, required])

  useEffect(() => {
    const element = editorElement.current
    return () => {
      if (name) {
        element.dispatchEvent(
          formEvent({
            action: 'REMOVE',
            name
          })
        )
      }
    }
  }, [name])

  return (
    <div ref={editorElement} className="text-editor">
      <label className="text-label">{label}</label>
      <DraftEditor
        initialContentState={contentState}
        spellCheck={true}
        onEditorStateChange={handleEditorStateChange}
        onBlur={flush}
      />
    </div>
  )
}

export default TextEditor
